import { initializeApp } from "firebase/app";
import { initializeFirestore, persistentLocalCache, connectFirestoreEmulator, } from "firebase/firestore";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
const env = () => globalThis.process?.env ?? {};
// Set FIREBASE_EMULATOR=1 to route Firestore + Auth at the local emulators (Doc 03 §6).
export const usingEmulators = () => env().FIREBASE_EMULATOR === "1";
export const initFirebase = (config, opts = {}) => {
    const app = opts.appName !== undefined ? initializeApp(config, opts.appName) : initializeApp(config);
    const db = initializeFirestore(app, {
        ...(opts.persistence === false ? {} : { localCache: persistentLocalCache() }),
        ...(opts.longPolling === true ? { experimentalForceLongPolling: true } : {}),
        ...(opts.autoDetectLongPolling === true ? { experimentalAutoDetectLongPolling: true } : {}),
    });
    const auth = getAuth(app);
    const functions = getFunctions(app);
    if (opts.emulators ?? usingEmulators()) {
        const host = opts.emulatorHosts?.firestore ?? env().FIRESTORE_EMULATOR_HOST ?? "127.0.0.1:8080";
        const [h, p] = host.split(":");
        connectFirestoreEmulator(db, h ?? "127.0.0.1", Number(p ?? "8080"));
        const authHost = opts.emulatorHosts?.auth ?? env().FIREBASE_AUTH_EMULATOR_HOST ?? "127.0.0.1:9099";
        connectAuthEmulator(auth, `http://${authHost}`, {
            disableWarnings: true,
        });
        const [fh, fp] = (opts.emulatorHosts?.functions ?? env().FUNCTIONS_EMULATOR_HOST ?? "127.0.0.1:5001").split(":");
        connectFunctionsEmulator(functions, fh ?? "127.0.0.1", Number(fp ?? "5001"));
    }
    return { app, db, auth, functions };
};
//# sourceMappingURL=app.js.map